export default __webpack_public_path__ + "locales/lo-LA/SalesDepartmentRequestDialog.json?hash=f7818ba42c0a6e820f4b581144a03cef";